/** @format */

import React from "react";
import { NavLink } from "react-router-dom";
import links from "../../utils/links";

const NavLinks = () => {
  const topLinks = links.slice(0, 5); // Get the first five links
  const bottomLinks = links.slice(5); // Get the last three links

  return (
    <div className="nav-links px-3 flex flex-col justify-between gap-8">
      <div className="space-y-2">
        {topLinks.map((link) => {
          const { text, path, id, icon: Icon } = link;
          return (
            <NavLink
              to={path}
              style={{outline: 0,border: "0"}}
              className="focus:text-white  focus:bg-indigo-600 flex items-center p-2  rounded-lg dark:text-dark text-gray-500 hover:text-white hover:bg-indigo-400 active:bg-indigo-600"
              key={id}
            >
              <Icon className=" transition duration-300 text-red hover:text-white stroke-current" />
              <span className="ml-3 transition duration-300 hover:text-white">
                {text}
              </span>
            </NavLink>
          );
        })}
      </div>
      <div className="mt-16 py-10 space-y-2">
        {bottomLinks.map((link) => {
          const { text, path, id, icon: Icon } = link;
          return (
            <NavLink
              style={{border: "0", outline:"0"}}
              to={path}
              className="focus:text-white  focus:bg-indigo-600 flex items-center p-2  rounded-lg dark:text-dark text-gray-500 hover:text-white hover:bg-indigo-400 active:bg-indigo-600"
              key={id}
            >
              <Icon className=" transition duration-300 text-red hover:text-white stroke-current" />
              <span className="ml-3 transition duration-300 hover:text-white">
                {text}
              </span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default NavLinks;
